import requestCustom from '@/utils/requestCustom'

const backlistApi = {

  // 查询合同详情

  getContractDetail(id) {
    return requestCustom({
      url: `/fdd/info/${id}`,
      method: 'get'
    })
  },

  // 创建交易合同
  createContract(data) {
    return requestCustom({
      url: '/saleOrder/contract',
      method: 'post',
      data
    })
  },

  /**
   * 创建中介订单合同
   * /middleman/order/contract
   */
  createMiddlemanContract(data) {
    return requestCustom({
      url: '/middleman/order/contract',
      method: 'post',
      data
    })
  },

  // 查询包赔资料
  getOrderDatum(id) {
    return requestCustom({
      url: `/order/datum/orderId/${id}`,
      method: 'get'
    })
  },

  // 订单列表
  getList(query) {
    return requestCustom({
      url: '/account/order/list',
      method: 'get',
      params: query
    })
  },
  // 换绑信息
  getDetail(id) {
    return requestCustom({
      url: `/account/order/${id}`,
      method: 'get'
    })
  },
  // 换绑信息2
  getDetail2(id) {
    return requestCustom({
      url: `/account/order/account/${id}`,
      method: 'get'
    })
  },

  // 以下新增于2023-10-06
  // 号商提号确认下单
  addOrder(data) {
    return requestCustom({
      url: '/saleOrder/create',
      method: 'post',
      data
    })
  },
  // 订单列表
  getListNew(query) {
    return requestCustom({
      url: '/saleOrder/list',
      method: 'get',
      params: query
    })
  },
  // 订单详情
  orderDetail(id) {
    return requestCustom({
      url: `/saleOrder/${id}`,
      method: 'get'
    })
  },
  // 立即支付 /saleOrder/payment  /pay/record/paymentTwo
  payNow(data) {
    return requestCustom({
      url: '/saleOrder/payment',
      method: 'post',
      data
    })
  },
  // 轮询订单支付状态
  orderPayStatusInterval(query) {
    return requestCustom({
      url: '/saleOrder/orderStatus',
      method: 'get',
      params: query
    })
  },
  // 支付后主动查询订单
  orderPayStatusHandle(data) {
    return requestCustom({
      url: '/saleOrder/queryOrder',
      method: 'post',
      data
    })
  },
  // 取消订单
  cancelOrder(data) {
    return requestCustom({
      url: '/saleOrder/cancelOrder',
      method: 'post',
      data
    })
  },
  // 修改订单价格
  editOrderPrice(data) {
    return requestCustom({
      url: '/saleOrder/updateAmount',
      method: 'post',
      data
    })
  },
  // 完成订单
  finishOrder(data) {
    return requestCustom({
      url: '/saleOrder/finishOrder',
      method: 'post',
      data
    })
  },
  // 一键拉群
  pullGroup(data) {
    return requestCustom({
      url: '/saleOrder/pullGroup',
      method: 'post',
      data
    })
  },
  // 解散群组
  cancelGroup(data) {
    return requestCustom({
      url: '/saleOrder/cancelGroup',
      method: 'post',
      data
    })
  },
  // huifu群组
  recoveryGroup(data) {
    return requestCustom({
      url: '/saleOrder/recoveryGroup',
      method: 'post',
      data
    })
  },
  // 查询订单关联的群组
  getToGroup(data) {
    return requestCustom({
      url: '/saleOrder/getToGroup',
      method: 'post',
      data
    })
  },
  // 转为交易中
  changeOrderStatus(data) {
    return requestCustom({
      url: '/saleOrder/changeOrderStatus',
      method: 'post',
      data
    })
  },
  // 修改支付状态
  editPayStatus(data) {
    return requestCustom({
      url: '/saleOrder/changePayStatus',
      method: 'post',
      data
    })
  },
  // 卖家发货
  saleOrderProfile(data) {
    return requestCustom({
      url: '/saleOrderProfile',
      method: 'post',
      data
    })
  },
  // 查看发货资料
  getSaleOrderProfile(saleOrderId) {
    return requestCustom({
      url: `/saleOrderProfile/bySaleOrderId/${saleOrderId}`,
      method: 'get'
    })
  },
  // 编辑发货信息
  editSaleOrderProfile(data) {
    return requestCustom({
      url: '/saleOrderProfile',
      method: 'put',
      data
    })
  },
  // 查询待结算的买家
  settlementBuyer() {
    return requestCustom({
      url: '/saleOrder/settlement/buyer',
      method: 'get'
    })
  },
  // 查询待结算的卖家
  settlementSeller() {
    return requestCustom({
      url: '/saleOrder/settlement/seller',
      method: 'get'
    })
  },
  // 查询待结算的订单
  settlementOrderList(params) {
    return requestCustom({
      url: '/saleOrder/settlement/list',
      method: 'get',
      params
    })
  },
  // 订单结算
  financialStatementSaleOrder(data) {
    return requestCustom({
      url: '/financialStatement/saleOrder',
      method: 'post',
      data
    })
  },
  // 订单统计列表
  saleOrderStatisticsList(params) {
    return requestCustom({
      url: '/saleOrder/statistics/list',
      method: 'get',
      params
    })
  },
  // 订单信息修改
  changeOrderInfo(data) {
    return requestCustom({
      url: '/saleOrder/changeOrderInfo',
      method: 'post',
      data
    })
  },
  // 导出待收款的订单
  exportSettlementOrderListBuyer(params) {
    return requestCustom({
      url: '/saleOrder/settlement/buy/export',
      method: 'get',
      params
    })
  },
  // 导出待结算的订单
  exportSettlementOrderListSeller(params) {
    return requestCustom({
      url: '/saleOrder/settlement/sell/export',
      method: 'get',
      params
    })
  },
  // 取消订单 卖家退款
  cancelOrderRepayment(data) {
    return requestCustom({
      url: '/financialStatement/seller/repayment',
      method: 'post',
      data
    })
  },

  // 通过id获取包赔资料详情
  getOrderDatumById(id) {
    return requestCustom({
      url: `/order/datum/toGroup/${id}`,
      method: 'get'
    })
  },

  // 修改包赔资料
  editOrderDatum(data) {
    return requestCustom({
      url: '/order/datum',
      method: 'put',
      data
    })
  },

  // 包赔资料审核
  auditOrderDatum(data) {
    return requestCustom({
      url: '/order/datum/audit',
      method: 'post',
      data
    })
  },

  // 上传账号密码
  uploadAccountPassword(data) {
    return requestCustom({
      url: '/order/datum/upload/account',
      method: 'post',
      data
    })
  },

  // 生成包赔证明
  /**
   * 生成包赔证明
   * @param {*} data 
   * @param {String} data.id 订单ID
   * @param {String} data.guaranteeInfoImg 游戏账号
   * @returns 
   */
  generateCompensationProof(data) {
    return requestCustom({
      url: '/saleOrder/saveGuaranteeInfoImg',
      method: 'put',
      data
    })
  },

  /**
   * 回收订单 发起账号密码
   * /saleOrder/speedySaleOrder
   */
  speedySaleOrder(data) {
    return requestCustom({
      url: '/saleOrder/speedySaleOrder',
      method: 'post',
      data
    })
  },
  /**
   * 回收订单卖家 填写账号密码 
   * /saleOrder/commitSpeedySaleOrder
   */
  commitSpeedySaleOrder(data) {
    return requestCustom({
      url: '/saleOrder/commitSpeedySaleOrder',
      method: 'put',
      data
    })
  },

  /**
   * 关联中介订单
   * /middleman/order/bindMiddleman
   */
  bindMiddleman(data) {
    return requestCustom({
      url: '/middleman/order/bindMiddleman',
      method: 'put',
      data
    })
  },

  /**
   * 中介订单发送账号密码
   * /middleman/order
   */
  sendMiddlemanAccount(data) {
    return requestCustom({
      url: '/middleman/order',
      method: 'put',
      data
    })
  },

  /**
   * 发送cmd消息，并定义包赔类型
   * /order/datum/sendDatum
   */
  sendDatumCmd(data) {
    return requestCustom({
      url: '/order/datum/sendDatum',
      method: 'post',
      data
    })
  },

  /**
   * 销售订单发送账号密码
   * /order/datum/pushUserRealAccount
   */
  sendSaleOrderAccount(data) {
    return requestCustom({
      url: '/order/datum/pushUserRealAccount',
      method: 'put',
      data
    })
  }
}
export default backlistApi
